import Flux from 'lib/flux';
import I from 'immutable';
import _ from 'underscore';
import TourAvailabilityConstants from 'constants/tour_availability';

const filterAvailableDates = function filterAvailableDates(guests, dates) {
  const availableDates = {};
  for (const date in dates) {
    if (dates[date]) {
      _.each(_.values(dates[date]), (slots) => {
        if (slots && slots >= guests) {
          availableDates[date] = dates[date];
        }
      });
    }
  }
  return availableDates;
};

const TourAvailabilityStore = Flux.createStore({
  name: 'tour_availability',

  getInitialState() {
    return {
      isLoading: false,
      dates: {},
      addon_availability: {},
      availableDates: {},
      availableTimes: I.Map({}),
      filtered: false,
      cached: {},
    };
  },

  actions: [
    [
      TourAvailabilityConstants.LOAD_DATES,
      function () {
        this.state = this.state.set('isLoading', true);
      },
    ],
    [
      TourAvailabilityConstants.LOAD_API_DATES_FINISHED,
      function (dates) {
        this.state = this.state.set('isLoading', false);
        this.state = this.state.setIn(['dates'], dates);
      },
    ],
    [
      TourAvailabilityConstants.FILTER_DATES,
      function (guests, date) {
        const availableDates = filterAvailableDates(
          guests,
          this.state.get('dates').toJS()
        );

        this.state = this.state.merge({
          availableDates,
          availableTimes: availableDates[date] || {},
          filtered: true,
        });
      },
    ],
    [
      TourAvailabilityConstants.GET_AVAILABLE_DATES,
      function () {
        this.state = this.state.set('isLoading', true);
      },
    ],
    [
      TourAvailabilityConstants.GET_AVAILABLE_DATES_FINISHED,
      function (dates) {
        this.state = this.state.set('isLoading', false);
        this.state = this.state.setIn(['dates'], dates);
      },
    ],
  ],
});

export default TourAvailabilityStore;
